import styled from "styled-components";

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 100;
`;

export const TitleGif = styled.img`
  z-index: 100;
  max-width: 80%;
`;
